<template>
  <!--    <div>-->
  <!--        <div>DEBUG blockName: {{blockName}}</div>-->
  <!--        <div>DEBUG block: {{block}}</div>-->
  <v-layout row wrap v-if="block && block.body">
    <template v-for="b in block.body">
      <template v-if="b.layout === 'one'">
        <v-flex xs12 v-html="b.column"></v-flex>
      </template>
      <template v-if="b.layout === '50-50'">
        <v-flex xs12 sm6 v-html="b.columnLeft"></v-flex>
        <v-flex xs12 sm6 v-html="b.columnRight"></v-flex>
      </template>
      <template v-if="b.layout === '4-4-4'">
        <v-flex xs12 sm4 v-html="b.columnLeft"></v-flex>
        <v-flex xs12 sm4 v-html="b.columnCenter"></v-flex>
        <v-flex xs12 sm4 v-html="b.columnRight"></v-flex>
      </template>
    </template>
  </v-layout>
  <!--    </div>-->
</template>

<script>
import {ebus} from "../vendor/ebus";

export default {
  name: "CmsBlock",
  props: ['blockName'],
  computed: {
    block() {
      try {
        let allPages = this.$store.getters.pages;
        let p = allPages.find(page => page.name === this.blockName);
        if (p) {
          return p;
        }else{
          ebus.$emit('triggerLoadPages');
        }
      } catch (e) {

      }
      return {};
    }
  },
}
</script>

<style scoped>

</style>
